import { SearchOutlined } from '@ant-design/icons';
import { DatePicker, Input, Select, Space } from 'antd';
import { memo, useEffect, useState } from 'react';
import { Operators } from '../../enum/operators.enum';
import { Predicate } from '../../models/predicate.model';
import { formatMomentLocalDateTime, nowDateTime } from '../../util/format';

interface TFiltrosTaxa {
    predicate: Predicate;
    findTaxaFixa: () => void;
}
const FiltrosTaxa = memo(({ predicate, findTaxaFixa }: TFiltrosTaxa) => {
    //export default function FiltrosTaxa({ predicate, findTaxaFixa }: TFiltrosTaxa) {
    const [descricao, setDescricao] = useState<string>();
    const [valorIni, setValorIni] = useState<number>();
    const [valorFin, setValorFin] = useState<number>();
    const [vigente, setVigente] = useState<string>();
    const [periodo, setPeriodo] = useState<moment.Moment>();

    useEffect(() => {
        const typingTimeout = setTimeout(() => {
            predicate.removeAllOption();

            if (descricao) {
                predicate.addOption('codigo', descricao, Operators.CONTAINS);
            }
            if (valorIni) {
                predicate.addMultiOption('valor', valorIni, Operators.GREATER_THAN_OR_EQUAL);
            }
            if (valorFin) {
                predicate.addMultiOption('valor', valorFin, Operators.LESS_THAN_OR_EQUAL, !!valorIni);
            }
            if (periodo) {
                predicate.addMultiOption('dataInicial', formatMomentLocalDateTime(periodo), Operators.LESS_THAN_OR_EQUAL);
                predicate.addMultiOption('dataFinal', formatMomentLocalDateTime(periodo), Operators.GREATER_THAN_OR_EQUAL);
            }

            switch (vigente) {
                case "1":
                    predicate.addMultiOption('dataInicial', nowDateTime(), Operators.LESS_THAN_OR_EQUAL, !!periodo);
                    predicate.addMultiOption('dataFinal', nowDateTime(), Operators.GREATER_THAN_OR_EQUAL, !!periodo);
                    break;
            }

            findTaxaFixa();
        }, 800);
        return () => clearTimeout(typingTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descricao, valorIni, valorFin, periodo, vigente]);

    return (
        <div className="filtros">
            <div className="input-text" style={{ width: '50%' }}>
                <Input id="buscar" value={descricao} placeholder="Buscar Taxa" prefix={<SearchOutlined style={{ color: '#6A7C96' }} rev={undefined} />} onChange={e => setDescricao(e.target.value)} />
            </div>
            <div className="filtro-estado" id="input-taxa" style={{ maxWidth: '30%' }}>
                <span style={{ whiteSpace: 'nowrap', marginRight: 5 }}>Faixa Preço</span>
                <Input style={{ marginRight: 5 }} type="number" onChange={e => setValorIni(parseInt(e.target.value))} />
                <Input type="number" onChange={e => setValorFin(parseInt(e.target.value))} />
            </div>
            <div className="filtro-estado" id="input-dashboard" style={{ maxWidth: '30%' }}>
                <span >Periodo</span>
                <Space direction="vertical" size={10}>
                    <DatePicker format={'DD-MM-YYYY'} onChange={(date) => setPeriodo(date)} style={{ fontSize: 10 }} />
                </Space>
            </div>
            <div className="filtro-estado" id="input-dashboard">
                <span>Status</span>
                <Select className="ant-dropdown-link" defaultValue="0" style={{ width: 120 }} onChange={e => setVigente(e)}>
                    <Select.Option value="0">Todos</Select.Option>
                    <Select.Option value="1">Vigente</Select.Option>
                </Select>
            </div>
        </div>
    )
})

FiltrosTaxa.displayName = 'FiltrosTaxa'

export default FiltrosTaxa;